import React, { useState } from "react";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";

const Faq = () => {
  // State to track which accordion item is open
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const { brandData } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName;
  const product = brandData?.logo?.productName;

  const productLower = product?.toLowerCase();
  let matchedProduct = null;

  if (productLower) {
    if (productLower.includes("curd")) matchedProduct = "curd";
    else if (productLower.includes("milk")) matchedProduct = "milk";
    else if (productLower.includes("paneer")) matchedProduct = "paneer";
    else if (productLower.includes("ghee")) matchedProduct = "ghee";
  }

  const productFaqs = {
    curd: [
      {
        q: "What is curd, and how is it different from yogurt?",
        a: "Curd is a dairy product made by fermenting milk using natural or added bacteria. It differs from yogurt mainly in the type of bacteria used and fermentation process.",
      },
      {
        q: "Is curd good for digestion?",
        a: "Yes, curd contains probiotics that can help in improving digestion and boosting gut health.",
      },
      {
        q: "Can curd be consumed by lactose intolerant individuals?",
        a: "Many lactose-intolerant individuals can tolerate curd better than milk because the fermentation process breaks down some of the lactose.",
      },
      {
        q: "How should curd be stored?",
        a: "Curd should be stored in the refrigerator below 4°C to maintain freshness and prevent spoilage.",
      },
      {
        q: "How is curd beneficial for the skin?",
        a: "Curd is rich in lactic acid, which can exfoliate and hydrate the skin, making it softer and more radiant.",
      },
    ],

    milk: [
      {
        q: "What are the nutritional benefits of milk?",
        a: "Milk is a good source of calcium, protein, and vitamins like B12 and D, essential for bone health and overall body function.",
      },
      {
        q: "What is the difference between full-fat, low-fat, and skimmed milk?",
        a: "Full-fat milk contains around 3.25% fat, low-fat milk has 1–2% fat, and skimmed milk has less than 0.5% fat.",
      },
      {
        q: "What is A2 milk, and how does it differ from regular milk?",
        a: "A2 milk contains only the A2 beta-casein protein and excludes A1 protein. This makes it easier to digest for some people. We maintain DNA-tested cows in dedicated farms to ensure certified A2 quality.",
      },
    ],

    paneer: [
      {
        q: "What is paneer, and how is it made?",
        a: "Paneer is an Indian cheese made by curdling milk with a food acid, then straining and pressing the curds.",
      },
      {
        q: "Is paneer a good source of protein?",
        a: "Yes, paneer is rich in protein and is a popular protein source for vegetarians.",
      },
      {
        q: "Is paneer suitable for weight loss?",
        a: "Paneer can be part of a weight-loss diet if consumed in moderation with a balanced diet.",
      },
      {
        q: "How can I keep paneer soft while cooking?",
        a: "Soak paneer in warm water for a few minutes after cooking to maintain softness.",
      },
    ],

    ghee: [
      {
        q: "Is ghee healthy for daily consumption?",
        a: "Ghee in moderation provides healthy fats and fat-soluble vitamins, but excess intake can lead to weight gain.",
      },
      {
        q: "Can ghee be used for high-temperature cooking?",
        a: "Yes, ghee has a high smoke point, making it suitable for frying and sautéing.",
      },
      {
        q: "How should ghee be stored?",
        a: "Ghee can be stored at room temperature in an airtight container; refrigeration extends shelf life.",
      },
      {
        q: "Does ghee have lactose or casein?",
        a: "Ghee contains negligible lactose and casein, making it easier to digest.",
      },
    ],
  };
//   console.log("product:", product);
//   console.log("matchedProduct:", matchedProduct);
//   console.log("productFaqs[matchedProduct]:", productFaqs[matchedProduct]);

  return (
    <div className="">
      {/* FAQ Section */}
      <div className="wrapper2">
        <br />
        <h2 className="heading2" style={{ textAlign: "center" }}>
          FAQ
        </h2>
        <div className="underline2 my-3 mx-1"></div>
      </div>
      <section className="py-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mx-auto">
              <div className="accordion accordion-flush osahan-faq">
                {/* FAQ 1 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 0 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(0)}
                    >
                      What makes {brandName} farming and production practices
                      unique?
                    </button>
                  </h2>
                  {openIndex === 0 && (
                    <div className="accordion-body border-top p-3">
                      Some unique {brandName} farming and production practices
                      include open housing farms 🏡 for the well-being of cows
                      🐄, proactive cow health monitoring 🩺, farm improvement
                      services supporting farmers like cow health monitoring,
                      state-of-the-art technology for transparency and quality,
                      rigorous quality assurance tests ✅, focus on
                      sustainability, and women empowerment with over 80% women
                      farmers 👩‍🌾.
                    </div>
                  )}
                </div>

                {/* FAQ 2 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 1 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(1)}
                    >
                      How does {brandName} ensure complete traceability in every
                      step of the product journey?
                    </button>
                  </h2>
                  {openIndex === 1 && (
                    <div className="accordion-body border-top p-3">
                      We ensure traceability through a comprehensive digital
                      dairy supply chain, made possible by state-of-the-art
                      technology platforms and applications, including but not
                      limited to:
                      <ul className="mt-2 mb-0 ps-3">
                        <li>
                          mooOn app and device for farm and herd management.
                          📱🔍
                        </li>
                        <li>
                          SmartAMCU app for management at Milk Grading and
                          Pricing Centres. 📲🔄
                        </li>
                        <li>
                          SmartCC app for Quality Assurance Hub management. 🏢📊
                        </li>
                        <li>ConTrak for cold chain monitoring. ❄️📡</li>
                      </ul>
                      <p className="mt-2 mb-0">
                        Please visit the mooMark website to know more.
                      </p>
                    </div>
                  )}
                </div>

                {/* FAQ 3 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 2 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(2)}
                    >
                      Can you explain what Farm Improvement Services (FIS) are
                      and how they benefit farmers?
                    </button>
                  </h2>
                  {openIndex === 2 && (
                    <div className="accordion-body border-top p-3">
                      FIS includes services like educating farmers on the best
                      practices 🌱, optimizing supply chains 🚚, and enhancing
                      milk quality.
                      <br />
                      <br />
                      <strong>Benefits for {brandName}:</strong>
                      <ul className="mt-2 mb-0 ps-3">
                        <li>Management of milk quality. 📊</li>
                        <li>Improved milk production. 🥛</li>
                        <li>
                          Veterinary support to ensure good health of cows. 🏡
                        </li>
                        <li>Nutrition management for optimal cow health. 🌾</li>
                        <li>
                          Guidance on herd composition for balanced farming. 🐄
                        </li>
                        <li>
                          Advice on breeding and reproduction best practices. 👩‍⚕️
                        </li>
                        <li>
                          Financial services: immediate payments, loans,
                          insurance, and advances. 💰
                        </li>
                        <li>
                          Farmer-centric activities like health camps, meetings,
                          and knowledge sessions. 👩‍🌾
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                {/* FAQ 4 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 4 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(4)}
                    >
                      How many farms, farmers, and cows are part of the mooMark
                      family?
                    </button>
                  </h2>
                  {openIndex === 4 && (
                    <div className="accordion-body border-top p-3">
                      We collaborate with 3.5 million farmers across 17 states
                      and 41,000 villages 🏡.
                      <br />
                      <br />
                      Our farming network includes over 80% women farmers 👩‍🌾 and
                      over 3.5 million cows 🐄.
                    </div>
                  )}
                </div>

                {/* FAQ 5 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 5 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(5)}
                    >
                      What measures does {brandName} take to ensure quality at
                      each stage of the product journey?
                    </button>
                  </h2>
                  {openIndex === 5 && (
                    <div className="accordion-body border-top p-3">
                      Our quality assurance involves:
                      <ul className="mt-2 mb-0 ps-3">
                        <li>
                          Monitoring over 150 parameters of cow health and
                          providing pre-emptive care using state-of-the-art
                          technology. 👩‍⚕️
                        </li>
                        <li>
                          Transparent quality testing at Milk Grading and
                          Pricing Centres with checks like fat & SNF percentage,
                          OT test, and more. 🧪
                        </li>
                        <li>
                          Testing at Quality Assurance Hubs for antibiotics,
                          MBRT, E. coli, Salmonella, and more. 🔬
                        </li>
                        <li>
                          39 rigorous quality checks during processing,
                          packaging, and final product testing. ✅
                        </li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* FAQ 6 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 6 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(6)}
                    >
                      What technology, devices, and platforms does {brandName}{" "}
                      utilize throughout its journey?
                    </button>
                  </h2>
                  {openIndex === 6 && (
                    <div className="accordion-body border-top p-3">
                      With the power of the Internet of Things (IoT) 🌐 and a
                      suite of advanced tools and platforms,
                      {brandName} ensures transparency, efficiency, and
                      traceability throughout its operations.
                      <br />
                      <br />
                      Our technologies include mooOn, smartAMCU, smartCC,
                      ConTrak, mooMark QR code for complete traceability,
                      SmartFarms, and mooPay.
                    </div>
                  )}
                </div>

                {/* FAQ 7 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 7 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(7)}
                    >
                      How does {brandName} demonstrate its commitment to
                      sustainability?
                    </button>
                  </h2>
                  {openIndex === 7 && (
                    <div className="accordion-body border-top p-3">
                      {brandName} aligns itself with 12 Sustainable Development
                      Goals (SDGs) 🌱 outlined by the United Nations:
                      <ul className="mt-2 mb-0 ps-3">
                        <li>
                          Farm Prosperity: Boosting farmer income through
                          interventions and financing. 💰🚜
                        </li>
                        <li>
                          Nutrition Security: Empowering farmers with steady
                          income through dairy farming. 🥛👩‍🌾
                        </li>
                        <li>
                          Healthier Practices: Training farmers in clean milk
                          practices. 🌱👨‍🌾
                        </li>
                        <li>
                          Gender Inclusivity: Elevating women farmers through
                          training and direct support. 👩‍🌾🌍
                        </li>
                        <li>
                          Clean Energy Adoption: Using biodigesters, solar
                          panels, and electric vehicles. ☀️🌿🚗
                        </li>
                        <li>
                          Fair Employment: Ensuring equitable wages and safe
                          working conditions. ⚖️👷‍♂️👷‍♀️
                        </li>
                        <li>
                          Financial Inclusion: Providing financial services to
                          micro-entrepreneurs. 💳💼
                        </li>
                        <li>
                          Reducing Inequality: Sustaining income growth for the
                          bottom 40%. 📉🌐
                        </li>
                        <li>
                          Rural Employment: Promoting gainful employment in
                          villages. 🏡👩‍🌾
                        </li>
                        <li>
                          Sustainable Practices: Integrating eco-friendly
                          operations. 🌍♻️
                        </li>
                        <li>
                          Climate Initiatives: Reducing GHG emissions and
                          adopting green practices. 🌿🌎
                        </li>
                        <li>
                          Collaborative Partnerships: Partnering with
                          institutions on climate and gender initiatives. 🤝🌐
                        </li>
                      </ul>
                    </div>
                  )}
                </div>

                {/* FAQ 8 */}
                <div className="accordion-item border rounded-4 overflow-hidden mb-3">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-bold ${
                        openIndex === 8 ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(8)}
                    >
                      List all the tests that {brandName} products undergo to
                      ensure quality and safety.
                    </button>
                  </h2>
                  {openIndex === 8 && (
                    <div className="accordion-body border-top p-3">
                      {brandName} conducts rigorous testing 🧪 to ensure
                      superior quality, safety, and premium taste ✨.
                      <br />
                      <br />
                      Each product undergoes over 50 tests 🌡️ — from farm-level
                      quality checks to final tests on packaged products ready
                      for dispatch. These include temperature monitoring,
                      organoleptic evaluations, alcohol, MBRT, acidity, SPC,
                      coliform, and other product-specific assessments.
                    </div>
                  )}
                </div>

                {matchedProduct &&
                  productFaqs[matchedProduct]?.map((faq, index) => {
                    const accordionIndex = 100 + index; // unique index for product FAQs

                    return (
                      <div
                        key={index}
                        className="accordion-item border rounded-4 overflow-hidden mb-3"
                      >
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button fw-bold ${
                              openIndex === accordionIndex ? "" : "collapsed"
                            }`}
                            type="button"
                            onClick={() => toggleAccordion(accordionIndex)}
                          >
                            {faq.q}
                          </button>
                        </h2>

                        {openIndex === accordionIndex && (
                          <div className="accordion-body border-top p-3">
                            {faq.a}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Faq;
